<script>
import axios from 'axios'

export const defaultFunction = () => {
  return ''
}

// 공백 제거
export const removeWhitespace = text => {
  const regex = /\s/g
  return text.replace(regex, '')
}

// 공백 제거 및 폰번호 변경
export const removeWhitespacePhone = text => {
  return text.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3')
}

// 일반 전화번호 포맷 변경
export const removeWhitespaceStandardPhone = text => {
  if (text.startsWith('02') && text.length === 9) {
    return text.replace(/(\d{2})(\d{3})(\d{4})/, '$1-$2-$3')
  } else if (text.length === 10) {
    return text.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3')
  } else if (text.length === 11) {
    return text.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3')
  }

  return text
}

// 전화번호형식 확인
export const validatePhone = phone => {
  const regex = /^\d{3}-\d{3,4}-\d{4}$/
  return regex.test(phone)
}

// 일반 전화번호 검증
export const validateStandardPhone = phone => {
  const regex = /^\d{2,3}-\d{3,4}-\d{4}$/
  return regex.test(phone)
}

// 영문숫자만
export const validateEngNum = text => {
  const regex = /^[a-zA-Z0-9]*$/
  return regex.test(text)
}

// 숫자만
export const validateNum = text => {
  const regex = /^[0-9]*$/
  return regex.test(text)
}

// 한글영문만
export const validateKorEng = text => {
  const regex = /^[가-힣a-zA-Z]+$/
  return regex.test(text)
}

// 패스워드형식 확인
export const validatePassword = password => {
  // eslint-disable-next-line
  const regex = /^(?=.*\d{1,50})(?=.*[~`!@#$%\^&*()-+=]{1,50})(?=.*[a-zA-Z]{2,50}).{8,50}$/
  return regex.test(password)
}

// email형식 확인
export const validateEmail = email => {
  // eslint-disable-next-line
  const regex = /^[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/
  return regex.test(email)
}

export const getTodayDate = (date_plus = 0) => {
  let now = new Date()
  // eslint-disable-next-line camelcase
  now.setDate(now.getDate() + date_plus)
  let todayYear = now.getFullYear()
  let todayMonth = (now.getMonth() + 1) > 9 ? (now.getMonth() + 1) : '0' + (now.getMonth() + 1)
  let todayDate = now.getDate() > 9 ? now.getDate() : '0' + now.getDate()

  return todayYear + '-' + todayMonth + '-' + todayDate
}

export const isWithinWorkingHours = async () => {
  const now = new Date()
  const day = now.getDay()
  const hour = now.getHours()
  const minute = now.getMinutes()

  let holidays = []
  try {
    const serviceKey = 'jJ7INGWCDjBB%2B3JpTb%2By4lkYoULhtshjBOQmwMaG5P8PMXMAcbBH4v3pGwUoOSnoro0VILo0E0fRBk0fF%2F5aMg%3D%3D'
    const year = now.getFullYear()
    const month = String(now.getMonth() + 1).padStart(2, '0')
    const response = await axios.get(
      `http://apis.data.go.kr/B090041/openapi/service/SpcdeInfoService/getRestDeInfo?ServiceKey=${serviceKey}&solYear=${year}&solMonth=${month}&_type=json`
    )
    const items = response.data.response.body.items.item
    if (items !== undefined) holidays = items.map(item => item.locdate.toString())
  } catch (error) {
    console.error('공휴일 정보를 가져오는데 실패했습니다:', error)
  }

  const todayString = now.toISOString().split('T')[0].replace(/-/g, '')
  const isHoliday = holidays.includes(todayString)
  const isWeekday = day >= 1 && day <= 5
  const isWithinHours = (hour > 9 || (hour === 9 && minute >= 30)) && hour < 18
  return isWeekday && isWithinHours && !isHoliday
}

export default{
  defaultFunction
}

</script>



// WEBPACK FOOTER //
// src/components/ETC/Validation.vue